import { render, staticRenderFns } from "./WorkflowJustificativa.vue?vue&type=template&id=4ab7e3c4"
import script from "./WorkflowJustificativa.vue?vue&type=script&lang=js"
export * from "./WorkflowJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports